import { Clipboard, ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginator } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { PromoCode } from '../../../domain/registrator';
import { DiscountValuePipe } from '../../../pipes/discount-value.pipe';
import { PromocodeService } from '../../../services/promocode.service';
import { PromocodeEditComponent } from '../promocode-edit/promocode-edit.component';
import { PromocodeGenComponent } from '../promocode-gen/promocode-gen.component';
import { MessageService } from '../../../services/message.service';
import { ConfirmDialogComponent } from '../../misc/confirm-dialog/confirm-dialog.component';



@Component({
  selector: 'app-event-promocodes',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatRadioModule,
    MatTableModule,
    MatCardModule,
    MatListModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatPaginator,
    MatTabsModule,
    MatDatepickerModule,
    MatSortModule,
    ClipboardModule,
    DiscountValuePipe
  ],
  templateUrl: './event-promocodes.component.html',
  styleUrl: './event-promocodes.component.scss'
})
export class EventPromocodesComponent implements OnInit, AfterViewInit {
  private readonly promocodeService = inject(PromocodeService);
  private readonly messageService = inject(MessageService);
  private readonly dialog = inject(MatDialog);
  private readonly clipboard = inject(Clipboard);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  event = this.route.parent!.snapshot.data['event'];

  promocodesListItems: PromoCode[] = [];
  promocodesDataSource: MatTableDataSource<PromoCode> = new MatTableDataSource();
  pageSize: number = 10;
  pageIndex: number = 0;
  showFirstLastButtons: boolean = true;
  pageSizeOptions = [5, 10, 25, 100];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  columnsToDisplay = ['id', 'code', 'description', 'discountRate', 'validUntil', 'uses', 'maxUses', 'active', 'actions'];

  constructor() { }

  ngOnInit() {
    this.loadPromoCodes();
  }

  ngAfterViewInit() {
    this.promocodesDataSource.paginator = this.paginator;
    this.promocodesDataSource.sort = this.sort;
    // this.sort!.active = 'id';  // Default sorting column
    // this.sort!.direction = 'asc'; // Default order (ascending)   
    // this.promocodesDataSource.sortingDataAccessor = (item, property) => {
    //   switch (property) {
    //     case 'customerName':
    //       return item.customer.name.toLowerCase(); // Ensure case-insensitive sorting
    //     case 'country':
    //       return item.customer.country.enName.toLowerCase(); // Ensure case-insensitive sorting          
    //     case 'fee':
    //       return item.fee.target.toLowerCase();
    //     default:
    //       return (item as Record<string, any>)[property];
    //   }
    // };
  }

  // get today(): Date {
  //   return new Date();
  // }

  loadPromoCodes() {
    this.promocodeService.getEventPromocodes(this.event.shortName, undefined).subscribe({
      next: (list) => {
        this.promocodesListItems = list;
        this.promocodesDataSource.data = this.promocodesListItems;

        let s = sessionStorage.getItem('promocodesListPageSize');
        if (s) {
          let page = parseInt(s);
          if (!isNaN(page)) {
            if (this.pageSizeOptions.includes(page)) {
              // console.log(`setting pagesize to ${s}`);
              this.pageSize = page;
            }
          }
        }
        s = sessionStorage.getItem('promocodesListCurrentPage');
        if (s) {
          let page = parseInt(s);
          if (!isNaN(page)) {
            if ((page > 0) && (page < Math.ceil(this.promocodesListItems.length / this.pageSize))) {
              // console.log(`jumping to page ${s}`);
              this.pageIndex = page;
            }
          }
        }
      },
      error: (error) => {
        console.log(error);
        if (error?.error?.message) {
          console.error('Error message:', error.error.message);
          this.messageService.showMessage('Error loading promocodes' + error.error.message.toLowerCase());
        } else {
          this.messageService.showMessage('Error loading promocodes');
        }
      }
    });
  }

  copyCodeToClipboard(c: PromoCode) {
    this.clipboard.copy(c.code);
    this.messageService.showMessage(`Promo code copied to clipboard.`);
  }

  editCode(c: PromoCode) {
    const dialogRef = this.dialog.open(PromocodeEditComponent, {
      width: '600px', // Set a width for the dialog
      minWidth: '600px',
      height: '600px',
      data: { code: c } // Pass data using the 'data' property
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed with result: ', result);
      if (result) {
        this.promocodeService.updatePromoCode(this.event.shortName, c.id, result).subscribe({
          next: (v) => {
            this.messageService.showMessage(`Successfully updated promocode`);
            this.loadPromoCodes();
          },
          error: (error) => {
            console.log(error);
            if (error?.error?.message) {
              console.error('Error message:', error.error.message);
              this.messageService.showMessage('Error adding promocode' + error.error.message.toLowerCase());
            } else {
              this.messageService.showMessage('Error updating promocode');
            }
          }
        });
      }
    });
  }

  toggleCode(c: PromoCode) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      buttonText: {
        ok: 'Yes',
        cancel: 'Cancel'
      }
    };
    if (c.active) {
      dialogConfig.data.message = (c.uses == 0 ? 'Are you sure you want to disable this promocode?' : 'This code has already been used. Are you sure you want to disable it?');
    } else {
      dialogConfig.data.message = 'Are you sure you want to re-enable this promocode?';
    }
    dialogConfig.height = '200px';
    dialogConfig.width = '600px';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        console.log((c.active ? 'disabling promocode' : 're-enabling promocode'), c.id);
        this.promocodeService.togglePromoCode(this.event.shortName, c.id).subscribe({
          next: (result) => {
            this.promocodeService.getEventPromocodes(this.event.shortName, undefined).subscribe({
              next: (list) => {
                this.promocodesListItems = list;
                this.promocodesDataSource.data = this.promocodesListItems;
                this.ngAfterViewInit();
                this.messageService.showMessage((c.active ? 'Promocode disabled' : 'Promocode re-enabled'));
              }

            })
          },
          error: (error) => {
            console.log(error);
            if (error?.error?.message) {
              console.error('Error message:', error.error.message);
              this.messageService.showMessage((c.active ? 'Error disabling promocode' : 'Error re-enabling promocode') + error.error.message.toLowerCase());
            } else {
              this.messageService.showMessage((c.active ? 'Error disabling promocode' : 'Error re-enabling promocode'));
            }
          }
        });
      }
    })
  }

  deleteCode(c: PromoCode) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      message: 'Are you sure you want to delete this promocode?',
      buttonText: {
        ok: 'Yes',
        cancel: 'Cancel'
      }
    };
    dialogConfig.height = '200px';
    dialogConfig.width = '600px';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        console.log('deleting promocode ', c.id);
        this.promocodeService.deletePromoCode(this.event.shortName, c.id).subscribe({
          next: (result) => {
            this.promocodeService.getEventPromocodes(this.event.shortName, undefined).subscribe({
              next: (list) => {
                this.promocodesListItems = list;
                this.promocodesDataSource.data = this.promocodesListItems;
                this.ngAfterViewInit();
                this.messageService.showMessage('Promocode deleted');
              }

            })
          },
          error: (error) => {
            console.log(error);
            if (error?.error?.message) {
              console.error('Error message:', error.error.message);
              this.messageService.showMessage('Error deleting promocode' + error.error.message.toLowerCase());
            } else {
              this.messageService.showMessage('Error deleting promocode');
            }
          }
        });
      }
    })
  }

  addCode() {
    const dialogRef = this.dialog.open(PromocodeEditComponent, {
      width: '600px', // Set a width for the dialog
      minWidth: '600px',
      height: '600px',
      data: {} // Pass data using the 'data' property
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed with result: ', result);
      if (result) {
        this.promocodeService.addPromoCode(this.event.shortName, result).subscribe({
          next: (v) => {
            this.messageService.showMessage(`Successfully added promocodes.`);
            this.loadPromoCodes();
          },
          error: (error) => {
            console.log(error);
            if (error?.error?.message) {
              console.error('Error message:', error.error.message);
              this.messageService.showMessage('Error adding promocode' + error.error.message.toLowerCase());
            } else {
              this.messageService.showMessage('Error adding promocode');
            }
          }
        });
      }
    });
  }

  generateCodes() {
    const dialogRef = this.dialog.open(PromocodeGenComponent, {
      width: '600px', // Set a width for the dialog
      minWidth: '600px',
      height: '600px',
      data: {} // Pass data using the 'data' property
    });
    dialogRef.afterClosed().subscribe(result => {
      console.debug('The dialog was closed with result: ', result);
      if (result) {
        this.promocodeService.generatePromoCodes(this.event.shortName, result).subscribe({
          next: (v) => {
            this.messageService.showMessage(`Successfully generated promocodes.`);
            this.loadPromoCodes();
          },
          error: (error) => {
            console.log(error);
            if (error?.error?.message) {
              console.error('Error message:', error.error.message);
              this.messageService.showMessage('Error generating promocodes' + error.error.message.toLowerCase());
            } else {
              this.messageService.showMessage('Error generating promocodes');
            }
          }
        });
      }
    });
  }

  announceSortChange(sortState: Sort) {
    console.debug('sort state', sortState);
  }

}
